import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Event } from '../../shared/models/event';
import { EventService } from '../services/event.service';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { Observable } from 'rxjs';
import { OrganizationService } from '../services/organization.service';


@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.css']
})
export class EventDialogComponent {

  private backupEvent: Partial<Event> = { ...this.data.event };
  ref!: AngularFireStorageReference;
  task!: AngularFireUploadTask;
  imageURL!: Observable<string>;
  showDateError: boolean = false;
  downloadableURL!: string

  constructor(
    public dialogRef: MatDialogRef<EventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EventDialogData,
    private eventService: EventService,
    private fireStorage: AngularFireStorage,
    private orgService: OrganizationService
  ) { }
  url: any = '';
  filePath!: string;
  async onFileSelected(event: any) {
    this.filePath = Math.random().toString(36).substring(2);
    console.log(this.filePath)
    this.ref = this.fireStorage.ref(this.filePath);
    this.task = this.ref.put(event.target.files[0]);
    this.imageURL = this.ref.getDownloadURL();
    console.log(this.imageURL)
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent) => {
        this.url = (<FileReader>event.target).result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
    (await this.task).ref.getDownloadURL().then(url => { this.downloadableURL = url; console.log(this.downloadableURL) }); // <<< url is found here

  }


  cancel(): void {
    this.dialogRef.close();
  }

  async post(): Promise<void> {
    const title = this.data.event.title ?? "";
    const image = this.downloadableURL
    const description = this.data.event.description ?? "";
    const location = this.data.event.location ?? "";
    const dateString = this.data.event.date ?? "";
    const time = this.data.event.time ?? "";
    const price = this.data.event.price ?? "";

    const date = Date.parse(dateString);

    if (Number.isNaN(date)) {
      this.showDateError = true;
      return;
    }

    const organization = this.orgService.org;

    await this.eventService.newEvent(title, description, organization, date, image, location, time, price);

    this.dialogRef.close(this.data);
  }

}

export interface EventDialogData {
  event: Partial<Event>;
  enableDelete: boolean;
}

export interface EventDialogResult {
  event: Event;
  delete?: boolean;
}


